{
  "instances": {
    "heapdump": {
      "label": "Heap Dump",
      "download": "Hala Heap Dump niður",
      "warn_dump_expensive": "þetta ferli getur verið dýrt með tilliti til CPU og geymslurýma.",
      "warn_sensitive_data": "Heap dump má innihalda gögn sem þurfa að vörn. Fjallið varlega."
    }
  }
}
